import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

export interface ActionItem {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
}

interface MoreActionsProps {
  label: string;
  groups: ActionItem[][];
}

const MoreActions: React.FC<MoreActionsProps> = ({ label, groups }) => {
  return (
    <UncontrolledDropdown>
      <DropdownToggle
        className="btn bg-primary text-white br-7 px-3 fs-14 fw-normal font-primary text-nowrap"
        tag="button"
      >
        {label}
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end  mt-2" container="body">
        {groups.map((group, gIndex) => (
          <div
            key={gIndex}
            style={{
              borderBottom:
                gIndex !== groups.length - 1 ? "1px solid #eee" : "none",
              paddingBottom: gIndex !== groups.length - 1 ? "8px" : "0px",
            }}
          >
            {group.map((item, index) => (
              <DropdownItem
                key={index}
                onClick={item.onClick}
                className="d-flex align-items-center gap-2 fs-15"
              >
                {item.icon}
                {item.label}
              </DropdownItem>
            ))}
          </div>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default MoreActions;
